import React, { useEffect, useRef, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { otpApi } from "../network/Network";

const Otp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [initialTime, setInitialTime] = useState(120); 
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const { email } = location?.state ?? {};
  const [formErrors, setFormErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const inputRefs = useRef([]);

  // Handle OTP input change
  const handleChange = (value, index) => {
    if (value.length === 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to next input if not on the last input
      if (index < 3 && value) {
        inputRefs.current[index + 1].focus();
      }
    }
  };
  //   Forgot Password Api
  const OtpHandler = (e) => {
    e.preventDefault();
	setLoading(true);
    let isValid = true;
    const errors = {};

    // Validate Email
    if (!otp) {
      if (!errors || !errors.otp) {
        if (!errors) errors = {};
        errors.otp = [];
      }
      errors.otp.push("otp is required");
      isValid = false;
    }

    setFormErrors(errors);
    setTimeout(() => {
      setFormErrors([]);
    }, 3000);
    const otpCode = otp.join("");
    const data = { email: email, otp: otpCode };
    otpApi(data)
      .then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          text: "OTP verified successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/create-new-password",{
			state : {
				email
			}
		});
        setLoading(false);
      })
      .catch((err) => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          text: `${err?.response?.data?.message}`,
          showConfirmButton: false,
          timer: 1500,
        })
        setLoading(false);
      });
  };
  //   =================
  return (
    <>
      <div className="main-banner-heading1">
        <Header />
      </div>
      <section className="signin">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="main-bg-signin">
                <h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
                  Otp
                </h2>
                <div>
                  <h4 className="primary-regular-font text-center mt-3 level-7 text-decoration-none mb-0">
                    We’ve sent a 4-digit OTP via email. It will expire in
                  </h4>
                </div>
                <div className="row mt-4">
                  {otp.map((_, index) => (
                    <div className="col-lg-3 mt-3" key={index}>
                      <div className="form-group">
                        <input
                          type="number"
                          className="form-control text-center"
                          maxLength={1}
                          value={otp[index]}
                          onChange={(e) => handleChange(e.target.value, index)}
                          ref={(el) => (inputRefs.current[index] = el)}
                          placeholder="0"
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <Link
                      onClick={OtpHandler}
                      className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
                      to="/create-new-password"
                    >
                      <span className="loading-btn loading bg-wrapper w-100">{loading ? <i className="fa fa-spinner"></i> : "Submit"}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Otp;
